import { Button, ButtonProps } from 'antd';
import React from 'react';
import { TextCommon } from '@esg/ui';

import { useTranslation } from 'react-i18next';
import { ButtonType } from 'antd/lib/button';
import { Block } from '../layouts';

export interface AppButtonProps extends Omit<ButtonProps, 'type'> {
    readonly translateCode?: string;
    readonly width?: React.CSSProperties['width'];
    readonly height?: React.CSSProperties['height'];
    readonly padding?: React.CSSProperties['padding'];
    readonly textAlign?: React.CSSProperties['textAlign'];
    readonly justifyContent?: React.CSSProperties['justifyContent'];
    readonly borderColor?: React.CSSProperties['borderColor'];
    readonly type?: ButtonType | 'secondary_blue';
    readonly flex?: React.CSSProperties['flex'];
    readonly backgroundColor?: React.CSSProperties['backgroundColor'];
}

export const AppButton = (props: AppButtonProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { children, translateCode, width, height, padding, textAlign, justifyContent, borderColor, type, className, classNames, flex, backgroundColor, ...rest } = props;
    const { t } = useTranslation();

    const style = React.useMemo((): React.CSSProperties => {
        return {
            width,
            padding,
            textAlign,
            justifyContent,
            borderColor,
            height,
            flex,
            backgroundColor
        };
    }, [borderColor, padding, textAlign, justifyContent, width, height, flex, backgroundColor]);

    return (
        <Button
            classNames={{
                icon: 'app-button-icon',
                ...classNames
            }}
            className={`app-button ${props.className} ${props.disabled ? 'app-button-disabled' : ''} `}
            style={{ ...style, opacity: props.disabled ? 0.4 : 1 }}
            {...rest}
            type={type as ButtonType}
        >
            {translateCode ? (
                <Block display='inline-block'><TextCommon fontSize={14}>{t(translateCode)}</TextCommon></Block>
            ) : (
                children
            )}
        </Button>
    );
};
